const dataStations = [
  {
    desc: "Marudi Junction 275/132/33kV Substation",
    type: "substation",
    category: "",
    NEcoord: [],
    coord: [
      // { lng: 114.0463271081119, lat: 4.252040957063205 },
      { lng: 114.045513, lat: 4.251774 },
    ],
  },
  {
    desc: "Murum Junction 275/33kV Substation (Hydropower 2.4GW Bakun and 0.944GW Murum)",
    type: "substation",
    category: "",
    NEcoord: [],
    coord: [
      // { lng: 114.1048350890586, lat: 2.890069665486774 },  
      { lng: 114.080030, lat: 2.885303},  
    ],
  },
  {
    desc: "Samalaju 275/132/33kV Substation",
    type: "substation",
    category: "",
    NEcoord: [],
    coord: [
      // { lng: 113.4334455936106, lat: 3.553206576056234 },
      { lng: 113.339791, lat: 3.526083 },
    ],
  },  
  {
    desc: "Similajau 500/275/33kV Substation",
    type: "substation",
    category: "",
    NEcoord: [],
    coord: [
      // { lng: 113.4768736918523, lat: 3.354732969627951 },
      { lng: 113.426935, lat: 3.352234 },
    ],
  },  
  {
    desc: "Pencawang Masuk Utama Selangau 275kV Substation",
    type: "substation",
    category: "",
    NEcoord: [],
    coord: [
      // { lng: 112.3454548134442, lat: 2.548463175460195 },
      { lng: 112.344719, lat: 2.551111 },
    ],
  },  
  {
    desc: "Bunut 500/275kV Substation",
    type: "substation",
    category: "",
    NEcoord: [],
    coord: [
      // { lng: 114.1813387378114, lat: 3.727067929458832 },
      { lng: 114.160161, lat: 3.728974 },
    ],
  },  
  {
    desc: "Balingian Substation",
    type: "substation",
    category: "",
    NEcoord: [],
    coord: [
      // { lng: 112.47219012483, lat: 2.73640811880597 },
      { lng: 112.470833, lat: 2.736185 },
    ],
  },
  {
    desc: "Tudan 275/132/33kV Miri Gas Power Station (75MW Generation)",
    type: "powerstation",
    category: "gas",
    NEcoord: [],
    coord: [
      // { lng: 114.0264279307449, lat: 4.480023641994299 },
      { lng: 114.034938, lat: 4.480054 },
    ],
  },
  {
    desc: "Bakun - Hydro Power Station",
    type: "powerstation",
    category: "hydro",
    NEcoord: [],
    coord: [
      // { lng: 114.0762249898098, lat: 2.773669078990755 },
      { lng: 114.050401, lat: 2.764032 },
    ],
  },
  {
    desc: "Balingian Power Station (624MW Coal)",
    type: "powerstation",
    category: "coal",
    NEcoord: [],
    coord: [
      // { lng: 112.4931184870547, lat: 2.744893279891061 },
      { lng: 112.475006, lat: 2.737188 },
    ],
  },
  {
    desc: "Mukah Power Station (270MW Coal)",
    type: "powerstation",
    category: "coal",
    NEcoord: [],
    coord: [
      // { lng: 112.336658142988, lat: 2.968209826018631 },
      { lng: 112.323055, lat: 2.967759 },
    ],
  },
];

export default dataStations;
